import "./Notification.scss";
import { JSLRender } from "jsl-render";
import { helper } from "../../core/helper";
var Notification = /** @class */ (function () {
    function Notification() {
    }
    Notification.show = function (options) {
        var _a;
        if (Notification.container == null) {
            Notification.createContainer();
        }
        // add
        var notification = {
            tag: "div",
            attr: { id: helper.newDomGuid(), style: options.style, class: "jsl-notification " + (options.class || "") },
            animation: { attr: "opacity", from: 0, to: 1, duration: 600 },
            children: [
                typeof options.content === "string" ? { tag: "div", content: options.content } : options.content
            ]
        };
        Notification.containerVNode.children.push(notification);
        Notification.renderer.refresh();
        // remove
        if (options.timeOut) {
            setTimeout(function () {
                var idx = Notification.containerVNode.children.indexOf(notification);
                if (idx >= 0) {
                    Notification.containerVNode.children.splice(idx, 1);
                }
                Notification.renderer.refresh();
            }, options.timeOut);
        }
        if (((_a = options.closeOnClick) !== null && _a !== void 0 ? _a : true) === true) {
            notification.attr.click = function () {
                var idx = Notification.containerVNode.children.indexOf(notification);
                if (idx >= 0) {
                    Notification.containerVNode.children.splice(idx, 1);
                }
            };
        }
    };
    Notification.clearAll = function () {
        Notification.containerVNode.children = [];
        Notification.renderer.refresh();
    };
    Notification.createContainer = function () {
        Notification.container = document.createElement("div");
        document.body.appendChild(Notification.container);
        Notification.container.className = "jsl-notification-container";
        Notification.containerVNode = { tag: "div", children: [] };
        Notification.renderer = new JSLRender(Notification.container, false);
        Notification.renderer.render(Notification.containerVNode);
    };
    return Notification;
}());
export { Notification };
